import React, { useState,useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import trLocale from "date-fns/locale/tr";
import axios from "src/utils/baseAxios";
import { connect } from "react-redux";
import { getUser } from "src/utils/Common";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  card: {
    background: "#fff",
    borderRadius: 20,
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    padding: theme.spacing(4),
  },
  field: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      backgroundColor: "#fff",

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E3EB",
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#1b84ff",
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#1b84ff",
        boxShadow: "0 0 0 1px rgba(27,132,255,0.25)",
      },
    },
    "& .MuiInputBase-input": {
      padding: "14px",
    },
  },
  saveButton: {
    background: "linear-gradient(90deg, #0079FF, #00B2FF)",
    color: "#fff",
    fontWeight: 700,
    textTransform: "none",
    padding: theme.spacing(1.2, 4),
    borderRadius: 12,
    boxShadow: "0 4px 10px rgba(27,132,255,0.3)",
    "&:hover": {
      background: "linear-gradient(90deg, #0063e6, #0091dd)",
    },
  },
}));

function CompensationExchange({ ReceiptNo,attachmentForm }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const { t } = useTranslation("overview");
  const [responseMessage, setresponseMessage] = useState({});
  const [warning, setWarning] = useState(false);
  const [warningType, setWarningType] = useState("info");
  const [isCompleted, setIsCompleted] = useState(false);
  const [files, setFiles] = useState([]);
  const [exchangeData, setExchangeData] = useState(null);

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    ExternalClaimId: "",
    ExternalClaimDate: new Date(),
    TradePartnerComment: "",
  });

  const [info, setInfo] = useState({
    ServiceName: "",
    ServiceAddress: "",
    HQNote: "",
  });

  const loadFullExchangeData = async () => {
    try {
      const res = await axios.get(`/TradePartner/GetExchangeData/${ReceiptNo}`);

      const exchange = res.data?.Exchange || null;
      const extraInfo = res.data?.ExtraInfo || null;

      setExchangeData(exchange);
      // EXTERNAL CLAIM FORM SET
      if (extraInfo) {
        setForm({
          ExternalClaimId: extraInfo.ExternalClaimId || "",
          ExternalClaimDate: extraInfo.ExternalClaimDate
            ? new Date(extraInfo.ExternalClaimDate)
            : new Date(),
          TradePartnerComment: extraInfo.TradePartnerComment || "",
        });

        setInfo({
          ServiceName: extraInfo.Dsc || "",
          ServiceAddress: extraInfo.FullAddress || "",
          HQNote: extraInfo?.CompensationHQNote || "",
        });
      }

    } catch (err) {
      console.error("Data load error:", err);
    }
  };

  useEffect(() => {
    loadFullExchangeData();
  }, [ReceiptNo]);

  const handleChange = (obj, key, value) => {
    obj === "form"
      ? setForm((p) => ({ ...p, [key]: value }))
      : setInfo((p) => ({ ...p, [key]: value }));
  };

  const statusUpdate = async (selectedWorkOrderId) => {
    var serviceShopId = SessionUser.ServiceShopId;
    try {
        const res = await axios.post(`/TradePartner/compensation-status-update/${selectedWorkOrderId}/${serviceShopId}`);

        if (res.data?.success) {
        setresponseMessage({
            ErrorCode: 0,
            ErrorDescription: "Status updated successfully ?",
        });
        setWarningType("success");
        setWarning(true);
        } else {
        setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: res.data?.errorMessage || "Update failed ?",
        });
        setWarningType("error");
        setWarning(true);
        }
    } catch (err) {
        setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: "Server error ?",
        });
        setWarningType("error");
        setWarning(true);
    }
  };

  const insertExchangeExtraInfo = async () => {
    try {
      const payload = {
        ExternalClaimId: form.ExternalClaimId,
        ExternalClaimDate: form.ExternalClaimDate,
        TradePartnerComment: form.TradePartnerComment,
        WorkOrderId: parseInt(ReceiptNo),
        ServiceShopId: null,
      };

      const res = await axios.post(
        "/TradePartner/InsertExchangeExtraInfo",
        payload
      );

      if (res.data?.success) {
        setresponseMessage({
          ErrorCode: 0,
          ErrorDescription: res.data?.message || "Inserted successfully ?",
        });
        setWarningType("success");
        setWarning(true);
      } else {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: res.data?.message || "Insert failed ?",
        });
        setWarningType("error");
        setWarning(true);
      }
    } catch (err) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: "Server error ?",
      });
      setWarningType("error");
      setWarning(true);
    }
  };

  
  const handleSave = async () => {
    setLoading(true);

    try {
        const dataBody = {
          WorkOrderId: parseInt(ReceiptNo),
          EmployeeId: SessionUser.TechnicianId,

          ChangeType: exchangeData?.Type || 1,
          ChangeGrade: exchangeData?.Grade || 2,
          ChangeReason: exchangeData?.Reason || 0,
          ChangeReasonDetail: exchangeData?.ReasonDetail || 0,
          ChangeReceived: exchangeData?.Received || 1,
          OperationSource: exchangeData?.OperationSource || 2,
          Upgrade: exchangeData?.Upgrade || 2,
          ChangeStatus: exchangeData?.Status || 1,
          ChangeServiceNote: exchangeData?.ServiceNote || "",
          ChangeBankName: exchangeData?.BankName || "",
          ChangeBankCode: exchangeData?.BankCode || "",
          ChangeIban: exchangeData?.Iban || "",
          ChangeInvoiceNr: exchangeData?.InvoiceNr || "",
          ChangeInvoicePrice: exchangeData?.InvoicePrice || 0,
          ChangeInvoiceDate: exchangeData?.InvoiceDate || null,
          ChangeProductId: exchangeData?.ProductId || 0,
          ChangeSoldto: exchangeData?.Soldto || null,
          ChangeShipto: exchangeData?.Shipto || null,
          ChangeSparePart: exchangeData?.SparePart || 0,
          SAP_Type: exchangeData?.SAP_Type || false,
          ExchangeMaterialOrderNr: exchangeData?.MaterialOrderNr || null,
          ChangeUnavailableMaterialParam: exchangeData?.UnavailableMaterialParam || [],
          CreateUserId: SessionUser.TechnicianId,
      };



      const res = await axios.post("/Technician/SetExChange", dataBody, {
        headers: { "Content-Type": "application/json" },
      });

      const result = res.data?.[0];

      if (result?.ErrorCode !== 0) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: result?.ErrorDescription || t("lblError"),
        });
        setWarningType("error");
        setWarning(true);
        setLoading(false);
        return;
      }

    await insertExchangeExtraInfo();

    await statusUpdate(ReceiptNo);

    if (Array.isArray(attachmentForm?.files) && attachmentForm.files.length > 0) {
      for (const file of attachmentForm.files) {
        const fileData = {
          Title: file.FileName || file.name,
          MIMEType: file.mimeType,
          FileData: file.FileData || file.base64,
          WorkOrderId: String(ReceiptNo),
          FileType: String(file.type) || 1,
        };

        try {
          await axios.post("/Technician/FileImportExport/SiriusFileUpload", fileData, {
            headers: { "Content-Type": "application/json" },
          });
        } catch (fileErr) {
          console.error("Error:", fileErr);
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t("lblFileUploadError"),
          });
          setWarningType("warning");
          setWarning(true);
        }
      }
    }
      setIsCompleted(true);
      setresponseMessage({
        ErrorCode: 0,
        ErrorDescription: t("exchangeSuccessMessage"),
      });
      setWarningType("success");
      setWarning(true);
      return;
    } catch (err) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t("lblError"),
      });
      setWarningType("error");
      setWarning(true);
    } finally {
      setLoading(false);
    }
  };

  const InfoField = ({ label, value }) => {
  return (
    <Box mb={2}>
      <Typography style={{ fontSize: 14, color: "#6b7280", marginBottom: 6 }}>
        {label}
      </Typography>

      <Box
        style={{
          width: "100%",
          border: "1px solid #E0E3EB",
          borderRadius: 12,
          background: "#f9fafb",
          padding: "14px 18px",
          fontSize: 15,
          color: "#1f2937",
          minHeight: 48,
          display: "flex",
          alignItems: "center",
        }}
      >
        {value || "-"}
      </Box>
    </Box>
  );
  };


  return (
    <Box>
      {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: "rgba(255,255,255,0.6)",
            backdropFilter: "blur(2px)",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={60} thickness={4} style={{ color: "#1b84ff" }} />
        </Box>
      )}

      <Card className={classes.card}>
         {isCompleted ? (
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="45vh" textAlign="center">
            <Typography variant="h5" style={{ fontWeight: 700, color: "#4CAF50", marginBottom: 16 }}>
              ? {t("exchangeSuccessTitle")}
            </Typography>
            <Typography variant="body1" style={{ fontSize: "1rem", color: "#333", marginBottom: 32 }}>
              {t("exchangeSuccessSubtext")}
            </Typography>
          </Box>
        ) : (
        <>
        <CardContent>
          <Grid container spacing={4}>

            {/* READONLY SERVICE INFO */}
            <Grid item xs={12} md={6}>
              <InfoField label="Service Name" value={info.ServiceName} />
              <InfoField label="Service Address" value={info.ServiceAddress} />
              <InfoField label="Compensation HQ Note" value={info.HQNote} />
            </Grid>

            {/* EXTERNAL FORM  */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    label="External Id"
                    fullWidth
                    variant="outlined"
                    margin="none"
                    className={classes.field}
                    value={form.ExternalClaimId}
                    onChange={(e) => handleChange("form", "ExternalClaimId", e.target.value)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={trLocale}>
                    <KeyboardDatePicker
                      label="External Date"
                      format="dd.MM.yyyy"
                      fullWidth
                      inputVariant="outlined"
                      margin="none"
                      className={classes.field}
                      value={form.ExternalClaimDate}
                      onChange={(date) => handleChange("form", "ExternalClaimDate", date)}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Trade Partner Comment"
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    className={classes.field}
                    value={form.TradePartnerComment}
                    onChange={(e) =>
                      handleChange("form", "TradePartnerComment", e.target.value)
                    }
                  />
                </Grid>
              </Grid>

              {/* SAVE BUTTON */}
              <Box display="flex" justifyContent="flex-end" mt={3}>
                <Button className={classes.saveButton} onClick={handleSave}>
                  Save
                </Button>
              </Box>
            </Grid>
          </Grid>
          {warning && (
                  <Box mt={3} display="flex" alignItems="center" justifyContent="center">
                    <Box
                      style={{
                        minWidth: "300px",
                        maxWidth: "650px",
                        padding: "16px 26px",
                        borderRadius: 14,
                        background:
                          warningType === "success"
                            ? "linear-gradient(90deg, #4CAF50, #81C784)"
                            : warningType === "error"
                            ? "linear-gradient(90deg, #f44336, #e57373)"
                            : "linear-gradient(90deg, #1b84ff, #00B2FF)",
                        color: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        fontFamily: "'Poppins','Inter',sans-serif",
                        fontWeight: 600,
                      }}
                    >
                      <span style={{ fontSize: 22 }}>{warningType === "success" ? "?" : warningType === "error" ? "?" : "??"}</span>
                      <Typography style={{ flex: 1, fontSize: "0.95rem", color: "#fff", lineHeight: 1.4 }}>
                        {responseMessage?.ErrorDescription || "-"}
                      </Typography>
                    </Box>
                  </Box>
              )}
        </CardContent>
        </>
        )}

           
             
          
      </Card>
    </Box>
  );
}


export default connect((state) => ({}), {})(CompensationExchange);
